import React, { useEffect, useRef } from "react";
import { Container } from "./styles";
import ellipse4 from "assets/ellipse4.png";
//import { ReactComponent as SheridanLogo } from "assets/sheridan-college-logo.svg";
//import { ReactComponent as ArkansasLogo } from "assets/arkansas-logo.svg";
import { ReactComponent as BHMSLogo } from "assets/bhms_logo.svg";
//import { ReactComponent as DublinCityLogo } from "assets/dcu-logo.svg";
//import { ReactComponent as ESELogo } from "assets/european-school-econ-logo.svg";
//import { ReactComponent as GISMALogo } from "assets/gisma-college.svg";
import SheridanLogo from "assets/Sheridan_College_Logo.png";
// import TrentLogo from "assets/Trent-University-Logo.png";
import TrentLogo from "assets/trent-uni-logo-2.png";
import UCWLogo from "assets/UCW_LOGO.jpeg";
// import BerlinLogo from "assets/BERLINLogo2.jpg";
import BerlinLogo from "assets/berlin-schoolo-of-business-and-innovation-2.png";
import DCULogo from "assets/Dublin-City-University-logo.png";

// import { gsap } from "gsap";
// import { ScrollTrigger } from "gsap/ScrollTrigger";
import { addToRefs } from "utils";
import AOS from "aos";
import "aos/dist/aos.css";

// gsap.registerPlugin(ScrollTrigger);

function Index({ header, title, btnText, desc, showEllipse }) {
  const headerRef = useRef(null);
  const titleRef = useRef(null);
  const logoWrapRef = useRef([]);

  const handleFindPrograms = () => {
    window.open("https://app.schooliply.com/#/guest/find-programs/programs", "_blank");
  };

  useEffect(() => {
    // gsap.from(headerRef.current, {
    //   y: 20,
    //   duration: 1,
    //   delay: 0.5,
    //   scrollTrigger: {
    //     trigger: headerRef.current,
    //     // markers: true,
    //     toggleActions: "play none none reverse"
    //   }
    // });
    // gsap.from(titleRef.current, {
    //   y: 20,
    //   duration: 1,
    //   delay: 0.5,
    //   scrollTrigger: {
    //     trigger: titleRef.current,
    //     // markers: true,
    //     toggleActions: "play none none reverse"
    //   }
    // });
    // gsap.from(logoWrapRef.current, {
    //   y: -10,
    //   duration: 1,
    //   delay: 0.5,
    //   scrollTrigger: {
    //     trigger: logoWrapRef.current,
    //     // markers: true,
    //     toggleActions: "play none none reverse"
    //   }
    // });
    AOS.init();
  }, []);

  return (
    <Container>
      <div className="wrapper">
        <span ref={headerRef} data-aos="fade-right" data-aos-duration="800">
          {header}
        </span>
        <p className="title" ref={titleRef} data-aos="fade-right" data-aos-duration="800">
          {title}
        </p>
        <p>{desc}</p>
        {showEllipse && <img src={ellipse4} alt="ellipse" />}
        <div
          className="logo-wrap"
          ref={(el) => addToRefs(el, logoWrapRef)}
          data-aos="fade-right"
          data-aos-duration="800"
        >
          <img src={SheridanLogo} alt="Sheridan Logo" className="schoolLogo" />
          <img src={TrentLogo} alt="Trent Logo" className="schoolLogo" />
          <img src={UCWLogo} alt="UCW Logo" className="schoolLogo" />
        </div>
        <div
          className="logo-wrap"
          ref={(el) => addToRefs(el, logoWrapRef)}
          data-aos="fade-right"
          data-aos-duration="800"
        >
          <BHMSLogo />
          <img src={DCULogo} alt="DCU Logo" className="schoolLogo" />
          <img src={BerlinLogo} alt="Berlin Logo" className="schoolLogo" />
        </div>
        <button onClick={handleFindPrograms}>{btnText}</button>
      </div>
    </Container>
  );
}

export default Index;
